import { FC } from 'react'
import { LockOutlined } from '@ant-design/icons'
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'
import classes from '../../styles/crmIntegrationChat.module.css'

const LockIcon = LockOutlined as unknown as FC<{ className?: string }>

type CrmIntegrationCommunityTabLockProps = {
  tooltip: string
}

const CrmIntegrationCommunityTabLock: FC<CrmIntegrationCommunityTabLockProps> = ({
  tooltip,
}) => (
  <TooltipWrapper placement="top" title={tooltip}>
    <span className={classes.communityTabLock} aria-label="Нет доступа">
      <LockIcon />
    </span>
  </TooltipWrapper>
)

export default CrmIntegrationCommunityTabLock
